/**
 * Serbian dinar.
 */
export var RSD = {
  code: 'RSD',
  base: 10,
  exponent: 2
};